import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import { axiosInstance } from 'services/api';
import { useContext, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { processAndSetData } from '../utils';

interface FetchEquipmentData {
  options?: { signal?: AbortSignal };
}

export default function useFetchEquipmentData() {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const { setEquipmentListData: setData } = useContext(EquipmentListContext);

  return useCallback(
    async ({ options: { signal } = {} }: FetchEquipmentData = {}) => {
      const equipmentResponse: any = await axiosInstance.get(
        '/api/user/equipment',
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          signal,
        },
      );
      const geofenceResponse: any = await axiosInstance.get(
        '/api/user/geofence',
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          signal,
        },
      );

      processAndSetData(
        equipmentResponse.data,
        geofenceResponse.data,
        setData,
        () => navigate('/equipment'),
        id,
      );
    },
    [setData, navigate, id],
  );
}
